import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../App.css';

const SuperAdminLayout: React.FC = () => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-layout super-admin-layout">
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      <aside className={`admin-sidebar super-admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button
          className="sidebar-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Toggle Sidebar"
        >
          {sidebarOpen ? '<' : '>'}
        </button>
        <div className="super-admin-badge">
          {t('superAdmin.badge')}
        </div>
        <nav className="admin-nav">
          <ul>
            <li>
              <Link to="/super-admin" onClick={() => setSidebarOpen(false)}>
                {t('superAdmin.sidebar.dashboard')}
              </Link>
            </li>
            <li>
              <Link to="/super-admin/organizations" onClick={() => setSidebarOpen(false)}>
                {t('superAdmin.sidebar.organizations')}
              </Link>
            </li>
            <li>
              <Link to="/super-admin/users" onClick={() => setSidebarOpen(false)}>
                {t('superAdmin.sidebar.users')}
              </Link>
            </li>
            <li>
              <Link to="/super-admin/contact" onClick={() => setSidebarOpen(false)}>
                {t('superAdmin.sidebar.contact')}
              </Link>
            </li>
            <li>
              <Link to="/super-admin/errors" onClick={() => setSidebarOpen(false)}>
                {t('superAdmin.sidebar.errors')}
              </Link>
            </li>
          </ul>
        </nav>
      </aside>
      <main className="admin-main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default SuperAdminLayout;
